var exports = {
  "KR": "xcc377c0b--9afe56--navigation-link",
  "G$": "xcc377c0b--9afe56--active-link",
  "Qs": "xcc377c0b--9afe56--content",
  "U9": "xcc377c0b--9afe56--count",
};

module.exports = exports;
